/** @format */
import React from 'react';

// import { useResizeDetector } from 'react-resize-detector';
import { Link } from 'react-router-dom';
import getRedirectionLink from '../../../utils/helper';

const CardLink = ({ link, mainLink }) => {
  return link.link ? (
    <a
      href={getRedirectionLink(link)}
      target={`${link.linkTarget === '_blank' ? '_blank' : ''}`}
      className={mainLink && 'main-link'}
    >
      <span className="card-text">{link.linkTitle}</span>
    </a>
  ) : (
    <Link to={getRedirectionLink(link)} className={mainLink && 'main-link'}>
      <span className="card-text">{link.linkTitle}</span>
    </Link>
  );
};

const CardMultiLink = props => {
  const { data } = props;
  if (!data) return <></>;

  return (
    <div className={`card-multi-link ${data.highlight && 'card-multi-link--highlight'}`}>
      {/* <img src={image} alt="card-icon" /> */}
      <div className="card-flex">
        <div className="card-title-container">
          <h2 className={`card-title`}>{data.title}</h2>
          {data.links && <CardLink link={data.links[0]} mainLink />}
        </div>
        {data.links && (
          <div className="others-link">
            <h4>Direct links</h4>
            {data.links.slice(1).map((link, index) => {
              return <CardLink link={link} key={index} />;
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export { CardMultiLink };
